import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useMemo, useState } from "react";
import { useARRSidebar } from "../../context/SidebarContext";
import { useEducationLevel } from "../../hooks/useEducationLevel";
import { useARRCode } from "../../context/ARRLevelContext";
import Select from "./Select";

const Sidebar = ({
  activeTab,
  setActiveTab,
  widgetContents,
  setWidgetContents,
  name,
  permittedARR,
}) => {
  const { arrLevel, setArrLevel } = useARRCode();
  const { educationLevel, loading } = useEducationLevel(name.includes("ARR"));
  const { collapse } = useARRSidebar();

  const [menu, setMenu] = useState(widgetContents[0]?.name);

  const isArrWidget = name.includes("ARR");

  //extract the permitted arr
  const arrOptions = useMemo(() => {
    if (!isArrWidget) return [];
    if (educationLevel?.length === 0 || permittedARR?.length === 0) return [];

    const filteredArr = educationLevel?.filter((level) => {
      const matched = permittedARR?.some((arr) => arr?.name === level?.label);
      return matched;
    });

    return filteredArr;
  }, [educationLevel, permittedARR]);

  const handleDropdown = (value) => {
    setMenu((prev) => (prev === value ? null : value));
  };

  //display selelcted widget arr in select
  useEffect(() => {
    if (!isArrWidget) return;
    if (arrOptions?.length > 0) {
      const matched = arrOptions.find((item) => item?.label === name);
      if (matched) {
        setArrLevel(matched.value);
      }
    }
  }, [name, arrOptions, setArrLevel]);

  //display first content of arr at first
  useEffect(() => {
    if (widgetContents?.length) {
      setMenu(widgetContents[0]?.name);
    }
  }, [widgetContents]);

  return (
    <aside className={`${collapse ? "sidebar-collapse" : ""} arr-sidebar`}>
      {isArrWidget && (
        <div style={{ marginBottom: "24px" }}>
          <Select
            isLoading={loading}
            options={arrOptions}
            value={arrOptions?.find((option) => option.value === arrLevel)}
            onChange={(option) => {
              setArrLevel(option?.value);
              setWidgetContents(() => {
                const selectedArr = permittedARR?.find(
                  (item) => item?.name === option?.label,
                );
                return selectedArr?.contents;
              });
            }}
            isClearable={false}
          />
        </div>
      )}
      {widgetContents?.map((item, idx) => {
        const active = item?.tabs?.find((a) => a.name === activeTab);
        return (
          <div key={item.name}>
            <div
              className={`${active ? "active" : ""} arr-tabs`}
              onClick={() => handleDropdown(item.name)}
            >
              <p>{item.name}</p>
              <FontAwesomeIcon
                icon={menu === item.name ? faChevronDown : faChevronRight}
              />
            </div>
            <div
              className={`${menu === item.name ? "active" : ""} arr-dropdown`}
            >
              {item.tabs.map((content) => (
                <p
                  key={content.name}
                  className={`${activeTab === content.name ? "active" : ""} item`}
                  onClick={() => setActiveTab(content.name)}
                >
                  {content.name}
                </p>
              ))}
            </div>
          </div>
        );
      })}
    </aside>
  );
};

export default Sidebar;
